<template>
  <div class="container">
    <div class="content">
      <div class="hearder">
        <div class="hearder_title">
          机构注册
        </div>
        <div
          class="steps"
        >
          <el-steps  :active="active" finish-status="success">
            <el-step  title="填写基本信息"></el-step>
            <el-step  title="完善机构资料"></el-step>
            <el-step  title="完成注册"></el-step>
          </el-steps>
        </div>
      </div>
      <!-- 各业务板块 -->
      <!-- 手机验证码验证 -->
      <information @changeStep="changeStep" v-if="active == 1" />
      <main-process @changeStep="changeStep"  v-if="active == 2"/>
      <finish @changeStep="changeStep" v-if="active == 3" />
      <tourist-tips @changeStep="changeStep" v-if="active == 5" />
      <!-- <institutional
        @changeStep="changeStep"
        :stepType="stepType"
        v-if="active == 2"
      />
      <reset-password v-if="active == 4" />
      <tourist-tips @changeStep="changeStep" v-if="active == 5" /> -->
    </div>
  </div>
</template>

<script>
import information from "./information.vue";
import institutional from "./institutional.vue";
import finish from "./finish.vue";
import resetPassword from "./resetPassword.vue";
import touristTips from "./touristTips.vue";
import mainProcess from "./mainProcess.vue";
export default {
  props: {},
  components: {
    information,
    institutional,
    finish,
    resetPassword,
    touristTips,
    mainProcess,
  },
  data() {
    return {
      title: "机构注册",
      stepType: "",
      active: 1,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.getLineParams();
  },
  methods: {
    // 获取平台码参数
    getLineParams() {
      document.title='机构注册'
      let { platformCode, loginPlatformCode,domain } = this.$route.query;
       console.log("参数注册页：", this.$route.query);
      sessionStorage.loginPlatformCode = loginPlatformCode || "420100";
      sessionStorage.platformCode = platformCode || "420100";
      sessionStorage.domain = domain || "https://yunnan.tianyuyun.com";
    },
    changeStep(val) {
      if (val === "tourist") {
        this.active = 2;
        this.stepType = val;
      } else {
        this.active = val;
      }
      this.filterTitle();
    },
    filterTitle() {
      if (this.active == 4) {
        this.title = "设置密码";
      } else if (this.active == 5) {
        this.title = "机构游客";
      } else if (this.stepType == "tourist") {
        this.title = "完善机构资料";
      } else {
        this.title = "机构注册";
      }
    },
  },
};
</script>

<style scoped lang="less">
.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  padding: 2% 0;
  background-color: #f4f4f4;
  .content {
    width: 80%;
    height: 100%;
    padding: 2%;
    overflow-y: auto;
    background-color: #fff;

    .hearder {
      width: 100%;
      .hearder_title {
        width: 100%;
        text-align: center;
        font-size: 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #eaeaea;
      }
      .steps {
        margin: 0 auto;
        margin-top: 4%;
        width: 50%;
      }
    }
  }
}
::v-deep .el-step__head.is-success {
  color:  #409eff;
  border-color:  #409eff;
}
::v-deep .el-step__title.is-success {
    font-weight: 400;
    color:  #409eff;
}
::v-deep .el-step__description.is-success {
    color:  #409eff;
}
::v-deep .el-step__title.is-process{
   font-weight: 400;
  border-color:  #C0C4CC;
   color: #C0C4CC;
}
::v-deep .el-step__head.is-process{
  color: #C0C4CC;
   border-color:  #C0C4CC;
}
</style>
